if (!customElements.get('collection-price-slider')) {
  class CollectionPriceSlider extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.minRange = this.querySelector('.collection-price-slider__input--min');
      this.maxRange = this.querySelector('.collection-price-slider__input--max');
      this.fill = this.querySelector('.collection-price-slider__fill');
      this.priceRange = this.parentElement?.querySelector('price-range');
      this.minField = this.priceRange?.querySelector('input[name$=".gte"]');
      this.maxField = this.priceRange?.querySelector('input[name$=".lte"]');

      if (!this.minRange || !this.maxRange || !this.minField || !this.maxField) return;

      this.dataset.initialized = 'true';
      this.minRange.addEventListener('input', () => this.onSliderInput('min'));
      this.maxRange.addEventListener('input', () => this.onSliderInput('max'));
      this.minRange.addEventListener('change', () => this.commitValue('min'));
      this.maxRange.addEventListener('change', () => this.commitValue('max'));
      this.minField.addEventListener('input', () => this.syncFromFields());
      this.maxField.addEventListener('input', () => this.syncFromFields());
      this.syncFromFields();
    }

    onSliderInput(changedHandle) {
      const minValue = Number(this.minRange.value);
      const maxValue = Number(this.maxRange.value);

      if (minValue > maxValue) {
        if (changedHandle === 'min') this.minRange.value = this.maxRange.value;
        else this.maxRange.value = this.minRange.value;
      }

      this.updateFill();
    }

    commitValue(changedHandle) {
      const range = changedHandle === 'min' ? this.minRange : this.maxRange;
      const field = changedHandle === 'min' ? this.minField : this.maxField;
      const boundary = changedHandle === 'min' ? Number(range.min) : Number(range.max);
      const value = Number(range.value);

      field.value = value === boundary ? '' : this.formatValue(value);
      field.dispatchEvent(new Event('change', { bubbles: true }));
    }

    syncFromFields() {
      const minimum = Number(this.minRange.min);
      const maximum = Number(this.maxRange.max);
      const minFieldValue = this.parseValue(this.minField.value);
      const maxFieldValue = this.parseValue(this.maxField.value);

      this.minRange.value = Number.isFinite(minFieldValue) ? minFieldValue : minimum;
      this.maxRange.value = Number.isFinite(maxFieldValue) ? maxFieldValue : maximum;
      this.onSliderInput('min');
    }

    updateFill() {
      const minimum = Number(this.minRange.min);
      const maximum = Number(this.maxRange.max);
      const span = maximum - minimum || 1;
      const start = ((Number(this.minRange.value) - minimum) / span) * 100;
      const end = ((Number(this.maxRange.value) - minimum) / span) * 100;

      this.fill.style.left = `${start}%`;
      this.fill.style.right = `${100 - end}%`;
    }

    parseValue(value) {
      if (!value) return Number.NaN;
      return Number(String(value).replace(/[^0-9.-]/g, ''));
    }

    formatValue(value) {
      return Number.isInteger(value) ? String(value) : value.toFixed(2);
    }
  }

  customElements.define('collection-price-slider', CollectionPriceSlider);
}
